// extracted by mini-css-extract-plugin
export default {"spinner":"CandyCaneSpinner_spinner__mX-8c","candy_cane_spinner":"CandyCaneSpinner_candy_cane_spinner__IoawA"};